<template>
  <v-row
    style="min-height: 100vh; flex-wrap: nowrap"
    :class="device.isDesktop ? 'fill-height' : 'flex-column'"
  >
    <payment-nav-drawer
      v-model="drawer"
      @openSettings="
        drawer = false;
        isSettingsDialogOpen = true;
      "
    ></payment-nav-drawer>
    <v-col
      :style="{
        order: !device.isDesktop ? 2 : 1,
      }"
      class="fill-height payment-orders-container"
      :class="{
        'pa-0': !recentOrders.length,
        'payment-bg-image': !recentOrders.length && device.isDesktop,
      }"
    >
      <img
        v-if="!recentOrders.length && device.isDesktop"
        src="/media/img/o-white.png"
        style="height: 10%; margin-left: 20px; margin-top: 20px"
      />
      <v-btn
        v-if="device.isDesktop"
        fab
        depressed
        color="primary"
        class="payment-drawer-button"
        @click="drawer = !drawer"
        aria-label="Open navigation"
      >
        <v-icon>mdi-menu</v-icon>
      </v-btn>
      <payment-alert
        v-if="settings.statusBox && recentOrders.length"
        :client="client"
        :countdown-seconds="countdownSeconds"
        :overlay="overlay"
        :settings="settings"
        :order="alertOrder"
        :color="alertOrder.color"
      ></payment-alert>
      <payment-info-box
        v-if="settings.infoBox && recentOrders.length"
        :order-info="orderInfo"
      ></payment-info-box>
      <v-row v-if="recentOrders.length">
        <v-col
          cols="12"
          class="slider-container"
          :style="{ minHeight: orderSliderMinHeight }"
        >
          <div class="slider-container">
            <transition-group
              name="slider"
              class="row slider-track pa-5"
              :class="!device.isDesktop && 'justify-center'"
            >
              <v-col
                v-for="(item, index) in recentOrders"
                :key="item.rb"
                v-if="item"
                :cols="
                  device.isMobile ? (item.success ? 12 : 12) : 12 / settings.colInRow
                "
                class="slider-item"
                :class="!device.isDesktop && 'mb-6'"
              >
                <payment-already-taken-card
                  v-if="item.state === 'already-taken'"
                  :item="item"
                  :settings="settings"
                  :last="index === recentOrders.length - 1"
                ></payment-already-taken-card>
                <payment-reserved-meal-card
                  v-else-if="item.state === 'reserved-meal'"
                  :item="item"
                  :settings="settings"
                  :last="index === recentOrders.length - 1"
                ></payment-reserved-meal-card>
                <payment-success-card
                  v-else-if="item.state === 'success'"
                  :item="item"
                  :settings="settings"
                  :last="index === recentOrders.length - 1"
                ></payment-success-card>
                <payment-stop-card
                  v-else-if="item.user"
                  :item="item"
                  :last="index === recentOrders.length - 1"
                  :settings="settings"
                ></payment-stop-card>
                <payment-unknown-card v-else></payment-unknown-card>
              </v-col>
            </transition-group>
          </div>
        </v-col>
      </v-row>
    </v-col>
    <v-col
      style="position: relative"
      :class="device.isDesktop ? 'payment-sidebar-desktop' : 'payment-sidebar-mobile'"
    >
      <v-row
        align="center"
        justify="center"
        :class="!device.isDesktop && (overlay ? 'error' : 'success')"
      >
        <v-col cols="12" v-if="device.isDesktop" class="grey lighten-4 pb-0 mb-2">
          <v-row align="center" justify="center" no-gutters class="py-2">
            <span class="mr-2 headline font-weight-medium">
              {{ orderDate.date | date }}
            </span>
            <edit-button @click="isSettingsDialogOpen = true"></edit-button>
          </v-row>
        </v-col>
        <v-col :cols="settings.typeTraffic === 'three' ? 4 : 3" sm="2" md="5" lg="12">
          <naplata-traffic-light
            v-if="['three', 'one'].includes(settings.typeTraffic)"
            :countdown="countdownSeconds"
            :type="settings.typeTraffic"
            :overlay="overlay"
          ></naplata-traffic-light>
          <overlay
            v-else
            :overlay="overlay"
            :client="client"
            :nextManual="settings.mode === 'manual'"
            :seconds="countdownSeconds"
          >
            <v-col
              cols="12"
              v-if="settings.mode === 'manual'"
              :class="!device.isDesktop && 'px-3'"
            >
              <button-next @next="overlay = false"></button-next>
            </v-col>
          </overlay>
        </v-col>
        <v-col lg="12" v-if="!device.isDesktop">
          <div v-if="!overlay">
            <span
              class="white--text font-weight-bold"
              style="font-size: 1.7rem; line-height: 1"
            >
              {{ $t("scan_qr_code") }}
            </span>
          </div>

          <div v-else>
            <span
              class="white--text font-weight-bold"
              style="font-size: 1.7rem; line-height: 1"
            >
              {{ $t("next_wait") }}
            </span>
          </div>
        </v-col>
        <v-col cols="auto" v-if="!device.isDesktop">
          <v-btn
            icon
            v-if="!device.isDesktop"
            color="white"
            class="payment-drawer-button"
            @click="drawer = !drawer"
            aria-label="Open navigation"
          >
            <v-icon>mdi-menu</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col cols="4" sm="auto" md="12" lg="12">
          <div
            :style="{
              height: !isRedLight ? qrScannerBoxHeight : 'auto',
              'aspect-ratio': !device.isDesktop ? 1 : 'auto',
            }"
            class="qr-scanner-box"
            :class="isRedLight ? 'qr-scanner-red' : 'qr-scanner-green'"
          >
            <qrcode-stream
              v-if="!isRedLight"
              @decode="handleQrCodeDecoded"
              @init="handleQrInit"
            ></qrcode-stream>
            <inactive-scanner-card v-else></inactive-scanner-card>
          </div>
        </v-col>
        <v-col cols="8" md="12" lg="12">
          <v-row align="center" justify="start" no-gutters v-if="!device.isDesktop">
            <span class="mr-2 headline font-weight-medium">
              {{ orderDate.date | date }}
            </span>
            <edit-button @click="isSettingsDialogOpen = true"></edit-button>
          </v-row>
          <v-text-field
            :label="$t('user_id')"
            v-model="userQrCode"
            append-icon="mdi-calculator"
            @click:append="show1 = !show1"
            @keyup.enter="handleQrCodeDecoded(false)"
            :messages="$t('enter_id')"
            filled
            color="primary"
            :style="{ fontSize: inputFontSize }"
          ></v-text-field>
          <button-next
            @next="overlay = false"
            v-if="device.isTablet && settings.mode === 'manual'"
          />
        </v-col>
        <v-col
          cols="12"
          v-if="settings.mode === 'manual' && !device.isTablet"
          :class="!device.isDesktop && 'px-3'"
        >
          <button-next @next="overlay = false"></button-next>
        </v-col>
        <v-col cols="6" md="12" class="pt-0" v-if="device.isDesktop">
          <div v-if="!overlay">
            <img
              :src="
                ['rs', 'rs-lat', 'en', 'sr'].includes($i18n.locale)
                  ? `./media/img/skeniraj-qr-kod-${$i18n.locale}.jpg`
                  : `./media/img/skeniraj-qr-kod-rs-lat.jpg`
              "
              height="auto"
              width="100%"
            />
          </div>

          <div v-else>
            <img
              :src="
                ['rs', 'rs-lat', 'en', 'sr'].includes($i18n.locale)
                  ? `./media/img/sledeci-${$i18n.locale}.jpg`
                  : `./media/img/sledeci-rs-lat.jpg`
              "
              height="auto"
              width="100%"
            />
          </div>
        </v-col>
      </v-row>

      <v-row
        style="position: absolute; bottom: 20px; width: 100%"
        v-if="!companySettings.confirm_delivery && alertOrder.success"
      >
        <v-col cols="12">
          <v-btn
            color="primary"
            block
            :height="mainButtonHeight"
            @click="processOrderPayment(client.id)"
            dark
          >
            Naplata
          </v-btn>
        </v-col>
      </v-row>

      <naplata-dialog-settings
        v-model="isSettingsDialogOpen"
        :settings="settings"
        :config="restaurantSettings"
        :date="orderDate"
        @setPreviousOrders="trimRecentOrders"
      />
    </v-col>
  </v-row>
</template>

<script>
import { QrcodeStream } from "vue-qrcode-reader";
import paymentService from "@/services/payment";
import PaymentSuccessCard from "@/components/canteen/cards/PaymentSuccessCard.vue";
import PaymentStopCard from "@/components/canteen/cards/PaymentStopCard.vue";
import PaymentAlreadyTakenCard from "@/components/canteen/cards/PaymentAlreadyTakenCard.vue";
import PaymentReservedMealCard from "@/components/canteen/cards/PaymentReservedMealCard.vue";
import PaymentUnknownCard from "@/components/canteen/cards/PaymentUnknownCard.vue";
import NaplataTrafficLight from "@/components/canteen/NaplataTrafficLight";
import setLang from "@/mixins/setLang";
import Overlay from "@/components/canteen/Overlay";
import NaplataDialogSettings from "@/components/canteen/dialogs/NaplataDialogSettings.vue";
import ButtonNext from "@/components/canteen/buttons/ButtonNext.vue";
import InactiveScannerCard from "@/components/canteen/cards/InactiveScannerCard.vue";
import PaymentNavDrawer from "@/components/canteen/layout/PaymentDrawer.vue";
import PaymentAlert from "@/components/canteen/layout/PaymentAlert.vue";
import PaymentInfoBox from "@/components/canteen/layout/PaymentInfoBox.vue";

export default {
  mixins: [setLang],
  components: {
    PaymentAlreadyTakenCard,
    Overlay,
    PaymentNavDrawer,
    PaymentAlert,
    PaymentReservedMealCard,
    InactiveScannerCard,
    QrcodeStream,
    ButtonNext,
    PaymentInfoBox,
    NaplataTrafficLight,
    NaplataDialogSettings,
    PaymentSuccessCard,
    PaymentStopCard,
    PaymentUnknownCard,
  },
  data() {
    return {
      loading: [],
      keyboardListener: null,
      numKeyboardListener: null,
      userQrCode: null,
      parsedQrResult: {
        arr: [],
        status: true,
        json: null,
      },
      orderInfo: "",
      alertOrder: {
        success: true,
        showStatusMessage: false,
        lastStatusMessage: "",
        color: "info",
      },
      countdownSeconds: 0,
      countdownInterval: null,
      recentOrders: [],
      isSettingsDialogOpen: false,
      overlay: false,
      settings: {
        hideSettingsButton: false,
        font: {
          size: { food: 24, user: 24 },
          uppercase: false,
        },
        mode: "auto",
        image: {
          size: 100,
        },
        autoDuration: 6,
        takeCurrentDate: true,
        colInRow: 3,
        typeTraffic: "one",
        clearPreviousOrdersTime: 120,
        infoBox: false,
        statusBox: false,
        language: "rs-lat",
      },
      orderSequenceNumber: 1,
      clearOrdersTimeoutId: null,
      drawer: false,
      canScan: true,
      orderDate: {
        date: new Date().toISOString().substr(0, 10),
      },
    };
  },
  mounted() {
    let parsedQrResult = this.parsedQrResult;
    this.numKeyboardListener = document.addEventListener("keydown", (e) => {
      if (e.keyCode === 107 && this.settings.mode === "manual") {
        this.overlay = false;
      }
    });

    this.keyboardListener = document.addEventListener(
      "keypress",
      (event) => {
        if (event.keyCode === 123 && this.canScan) {
          this.canScan = false;
          setTimeout(() => {
            this.canScan = true;
          }, 1000);

          parsedQrResult.status = true;
          parsedQrResult.json = null;
          parsedQrResult.arr = [];
        }
        if (parsedQrResult.status) {
          if (event.keyCode !== 13) parsedQrResult.arr.push(event.key);
          if (event.keyCode === 13) {
            parsedQrResult.json = parsedQrResult.arr.join("");
            parsedQrResult.status = false;
          }
        }
      },
      true
    );
    // Schedule daily update of date at the first second of each day
    const scheduleNextDateUpdate = () => {
      const now = new Date();
      const tomorrow = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate() + 1,
        0,
        0,
        1,
        0
      );
      const msUntilTomorrow = tomorrow.getTime() - now.getTime();
      setTimeout(() => {
        if (this.settings.takeCurrentDate) {
          this.orderDate.date = this.getNewDate();
        }
        scheduleNextDateUpdate();
      }, msUntilTomorrow);
    };
    scheduleNextDateUpdate();

    const savedSettings = localStorage.getItem("naplata-settings");
    if (savedSettings) {
      this.settings = JSON.parse(savedSettings);
      this.$i18n.locale = this.settings.language || this.$i18n.locale;
    } else {
      this.settings.language = this.$i18n.locale;
      const companies = this.user?.companies || [];
      if (companies && companies[0]) {
        if (
          companies[0].general_type === "complete_meal" &&
          this.settings?.font?.size?.food
        ) {
          this.settings.font.size.food = 32;
        }
      }
    }
  },
  methods: {
    getNewDate() {
      const now = new Date();
      return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(
        2,
        "0"
      )}-${String(now.getDate()).padStart(2, "0")}`;
    },
    handleQrInit(promise) {
      promise.catch((error) => {
        if (error.name === "NotAllowedError") {
          this.qrPermissionDenied = true;
          this.qrErrorMessage = "";
          console.warn("QR Code permission denied:", error);
        } else if (error.name === "NotFoundError") {
          this.qrErrorMessage = "qr_camera_not_found";
        } else if (
          error.name === "NotReadableError" ||
          error.name === "TrackStartError"
        ) {
          this.qrErrorMessage = "qr_camera_in_use";
        } else if (error.name === "OverconstrainedError") {
          this.qrErrorMessage = "qr_camera_constraints";
        } else {
          // this.qrErrorMessage = "qr_unknown_error";
          this.qrErrorMessage = error.name;
        }
      });
    },
    resetClearOrdersTimer() {
      if (this.clearOrdersTimeoutId) {
        clearTimeout(this.clearOrdersTimeoutId);
      }

      this.clearOrdersTimeoutId = setTimeout(() => {
        this.recentOrders = [];
      }, this.settings.clearPreviousOrdersTime * 1000);
    },
    trimRecentOrders() {
      this.recentOrders.splice(this.settings.colInRow);
    },
    handleQrCodeDecoded(decodedString) {
      if (this.isRedLight) {
        return;
      }

      if (this.settings.takeCurrentDate) {
        this.orderDate.date = this.getNewDate();
      }

      this.alertOrder.showStatusMessage = false;
      const userId = decodedString ? JSON.parse(decodedString).id : this.userQrCode;
      this.userQrCode = userId;

      if (!this.userQrCode) {
        return;
      }

      paymentService
        .getOrderGroupByUserTesting(this.userQrCode, {
          date: this.orderDate.date,
          lang: this.settings.language,
        })
        .then(async (res) => {
          this.orderInfo = res.data.data;
          this.alertOrder.success = res.data.data.success;
          this.alertOrder.lastStatusMessage = res.data.data.text;
          this.alertOrder.showStatusMessage = !!res.data.data.text;

          if (this.orderInfo.user) {
            this.orderInfo.user.message = {
              success: res.data.data.success,
              lastStatusMessage: res.data.data.text,
            };
          }

          if (res.data.data.sound) {
            new Audio("./sounds/" + res.data.data.sound).play();
          } else if (
            res.data.data.text ===
            "Niste naručili na vrijeme, restoran nema zamensko obrok"
          ) {
            //ToDo Ovo je temporary fix, treba da dodamo na apiju da vrati zvuk kada nije narucio i nema zamenskog obroka
            new Audio("./sounds/greska-nije-izvrsena-narudzba.mp4").play();
          }

          if (this.companySettings.confirm_delivery && this.alertOrder.success) {
            await this.processOrderPayment(userId);
          }

          this.addOrderToRecent();

          setTimeout(() => {
            this.alertOrder.showStatusMessage = false;
          }, 6000);
        })
        .catch((error) => {
          console.error("❌ [API] Order fetch failed:", error);
          console.error("🔍 [DEBUG] Error details:", {
            message: error.message,
            status: error.response?.status,
            data: error.response?.data,
          });
        })
        .finally(async () => {
          this.overlay = true;
          if (this.settings.mode === "auto") {
            await this.initializeCountdownTimer();
            this.startCountdownInterval();
          }
        });
    },
    addOrderToRecent() {
      let packageForSaving = null;
      let state = "success";

      if (this.orderInfo.text === "Već preuzeto") {
        state = "already-taken";
      } else if (
        this.orderInfo.text ===
        "Niste naručili na vrijeme, možete preuzeti zamjenski obrok"
      ) {
        state = "reserved-meal";
      }

      if (this.orderInfo.orders) {
        packageForSaving = {
          order: this.orderInfo.orders[0],
          user: this.client,
          success: true,
          state,
        };
      } else if (this.orderInfo["order-reserved-not-group"]) {
        const order = this.orderInfo["order-reserved-not-group"];
        packageForSaving = {
          order: {
            transaction: [
              {
                quantity: order?.quantity || 1,
                food: {
                  image: {
                    name: order.image?.name,
                  },
                  name: order.name,
                },
              },
            ],
          },
          user: this.client,
          success: true,
          state,
        };
      } else if (this.orderInfo["orders-not-group"]) {
        packageForSaving = {
          user: this.client,
          success: true,
          order: {
            shift: parseInt(
              this.orderInfo["orders-not-group"][0].shift.split("-")[0] || 1
            ),
            transaction: [
              {
                shift: parseInt(
                  this.orderInfo?.["orders-not-group"]?.[0]?.shift?.split?.("-")?.[0] ?? 1
                ),
                quantity: this.orderInfo["orders-not-group"]?.[0]?.quantity || 1,
                food: {
                  image: {
                    name: this.orderInfo["orders-not-group"][0].meals.image?.name,
                  },
                  name: this.orderInfo["orders-not-group"][0].meals.name,
                  translation: this.orderInfo["orders-not-group"][0].meals?.name || ""
                },
              },
            ],
          },
          state,
        };
      } else if (this.orderInfo["orders-reserved"]) {
        packageForSaving = {
          user: this.client,
          success: true,
          order: {
            transaction: [
              {
                quantity: this.orderInfo["orders-reserved"]?.[0]?.quantity || 1,
                food: {
                  image: {
                    name: this.orderInfo["orders-reserved"][0].image.name,
                  },
                  name: this.orderInfo["orders-reserved"][0].name,
                },
              },
            ],
          },
          state,
        };
      } else if(this.orderInfo['order-more-restaurant']) {
        packageForSaving = {
          order: {
            // transaction: [
            //   {
            //     quantity: this.orderInfo["order-more-restaurant"][0]['order_guest_more_transactions'][0].quantity || 1,
            //     food: {
            //       image: {
            //         name: this.orderInfo["order-more-restaurant"][0]['order_guest_more_transactions'][0].meals?.image?.name || this.orderInfo["order-more-restaurant"][0]['order_guest_more_transactions'][0].food?.image?.name || "",
            //       },
            //       name: this.orderInfo["order-more-restaurant"][0]['order_guest_more_transactions'][0].meals?.name || this.orderInfo["order-more-restaurant"][0]['order_guest_more_transactions'][0].food?.name || "",
            //     },
            //   },
            // ],

            transaction: (this.orderInfo["order-more-restaurant"] || []).flatMap(restaurant => {
              const transactions = restaurant['order_guest_more_transactions'] || [];

              return transactions.map(trans => {

                const mealOrFood = trans.meals || trans.food || {};
                const imageName = mealOrFood.image?.name || "";
                const foodName = mealOrFood.name || "";

                return {
                  quantity: trans.quantity || 1,
                  food: {
                    image: {
                      name: imageName,
                    },
                    name: foodName,
                  },
                };
              });
            })
          },
          user: this.client,
          success: true,
          state,
        };
      } else {
        packageForSaving = {
          user: this.client,
          success: false,
          message: this.orderInfo.text,
          state: null,
        };
      }
      this.pushWithLimit(packageForSaving);
    },
    processOrderPayment(userId) {
      if (this.loading.includes(userId)) {
        return;
      }
      if (
        this.orderInfo.orders ||
        this.orderInfo["orders-reserved"] ||
        this.orderInfo["orders-not-group"] ||
        this.orderInfo["order-reserved-not-group"] ||
        this.orderInfo["order-more-restaurant"]
      ) {
        let params = {};

        if (this.orderInfo.orders) {
          params = { order_foods_id: this.orderInfo.orders[0].id };
        } else {
          params = {
            user_id: userId,
            restaurant_id: this.company.restaurant.id,
            company_id: this.company.id,
            shift: 1,
            date: this.orderDate.date,
            type: 1,
          };

          if (this.orderInfo["orders-not-group"]) {
            params.meal_id = this.orderInfo["orders-not-group"][0].id;
            let quantity = this.orderInfo?.["orders-not-group"]?.[0]?.quantity;
            if (quantity) params.quantity_payed = quantity;
          } else if (this.orderInfo["orders-reserved"]) {
            params.food_id = this.orderInfo["orders-reserved"][0].id;
          } else if (this.orderInfo["order-reserved-not-group"]) {
            params.meal_id = this.orderInfo["order-reserved-not-group"].id;
          } else if (this.orderInfo["order-more-restaurant"]) {
            params.order_more_restaurant_id = this.orderInfo["order-more-restaurant"].map(i => i.id);
          }
        }
        this.loading.push(userId);
        return paymentService
          .processOrderTakeOver(params)
          .then((res) => {
            this.alertOrder.lastStatusMessage = this.$t("successful");
          })
          .catch((err) => {
            console.error("❌ [API] Order takeover failed:", err);
            console.error("🔍 [DEBUG] Payment error details:", {
              message: err.message,
              status: err.response?.status,
              data: err.response?.data,
            });
            this.alertOrder.lastStatusMessage = this.$t("error");
          })
          .finally(() => {
            const index = this.loading.indexOf(userId);
            if (index > -1) {
              this.loading.splice(index, 1);
            }
            this.alertOrder.showStatusMessage = true;
          });
      } else {
      }
    },
    initializeCountdownTimer() {
      this.countdownSeconds = Math.max(parseInt(this.settings.autoDuration || 0), 0);
    },
    startCountdownInterval() {
      clearInterval(this.countdownInterval);
      this.countdownInterval = setInterval(() => {
        this.countdownSeconds--;
        if (this.countdownSeconds <= 0) {
          clearInterval(this.countdownInterval);
          this.overlay = false;
        }
      }, 1000);
    },
    pushWithLimit(value) {
      const lastOrder = this.recentOrders[0];

      const isSameUser =
        (lastOrder?.user == null && value?.user == null) ||
        (lastOrder?.user && value?.user && lastOrder.user.id === value.user.id);

      if (!isSameUser || !lastOrder) {
        value.rb = this.orderSequenceNumber;
        this.orderSequenceNumber++;
        this.recentOrders.unshift(value);

        if (this.recentOrders.length > this.settings.colInRow) {
          const removed = this.recentOrders.pop();
        }

        this.resetClearOrdersTimer();
      } else {
      }
    },
  },
  computed: {
    isRedLight() {
      return this.overlay || this.countdownSeconds > 0;
    },
    client() {
      return this.orderInfo.user || null;
    },
    company() {
      return this.$store.state.user.user.companies[0];
    },
    companySettings() {
      return JSON.parse(this.company.settings);
    },
    restaurantSettings() {
      return this.company.restaurant.settings;
    },
    orderSliderMinHeight() {
      if (this.device?.isMobile) return "200px";
      if (this.device?.isTablet) return "300px";
      return "400px";
    },
    qrScannerBoxHeight() {
      if (this.device?.isMobile) return "auto";
      if (this.device?.isTablet) return "150px";
      return "120px";
    },
    inputFontSize() {
      if (this.device?.isMobile) return "14px";
      if (this.device?.isTablet) return "16px";
      return "18px";
    },
    mainButtonHeight() {
      if (this.device?.isMobile) return "48";
      if (this.device?.isTablet) return "64";
      return "80";
    },
    user() {
      return this.$store.state.user.user;
    },
  },
  watch: {
    "settings.takeCurrentDate"(newValue) {
      if (newValue) {
        this.orderDate.date = this.getNewDate();
      }
    },
    isRedLight(isRedLight) {
      this.alertOrder.color = isRedLight ? "error" : "success";
    },
    "parsedQrResult.status"() {
      if (
        this.parsedQrResult.json &&
        typeof JSON.parse(this.parsedQrResult.json) !== "number"
      ) {
        this.handleQrCodeDecoded(this.parsedQrResult.json);
      }
    },
    settings: {
      handler() {
        localStorage.setItem("restaurant-pay-settings", JSON.stringify(this.settings));
      },
      deep: true,
    },
    "restaurantSettings.timer"() {
      if (this.restaurantSettings.timer) {
        this.settings.autoDuration = this.restaurantSettings.timer;
      }
    },
    "settings.mode"() {
      clearInterval(this.countdownInterval);
      this.overlay = false;
      this.countdownSeconds = 0;
    },
  },
  filters: {
    date(date) {
      const d = new Date(date);
      return `${d.getDate()}.${d.getMonth() + 1}.${d.getFullYear()}.`;
    },
  },
  beforeDestroy() {
    if (this.numKeyboardListener) {
      document.removeEventListener("keydown", this.numKeyboardListener);
    }
    if (this.keyboardListener) {
      document.removeEventListener("keypress", this.keyboardListener);
    }
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  },
};
</script>

<style lang="scss">
@import "@/assets/styles/_variables.scss";

.slider-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.slider-track {
  position: relative;
}

.slider-item {
  flex-shrink: 0;
}

/* Slide efekat */
.slider-move {
  transition: transform 0.4s ease;
}

.slider-enter-active {
  transition: transform 0.4s ease, opacity 0.4s ease;
}
.slider-enter {
  transform: translateX(100%);
  opacity: 0;
}

/* Ova klasa se NE koristi jer ne animiramo leave direktno */
.slider-leave-active {
  position: absolute;
}
.slider-leave-to {
  opacity: 0;
  transform: translateX(-100%);
}
.payment-bg-image {
  background-position: center;
  background-image: url("@/assets/bg-preuzmi.webp");
  background-size: cover;
}
.payment-orders-container {
  position: relative;
  background-color: rgba(0, 0, 0, 0.02);
}
.payment-drawer-button {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 20;
}
.payment-sidebar-desktop {
  order: 2;
  width: 300px;
  max-width: 300px;
}
.payment-sidebar-mobile {
  order: 1;
  width: 100%;
  max-width: 100%;
  flex-grow: 0;
}
.qr-scanner-box {
  border-radius: 2px;
}
.qr-scanner-red {
  border: 2px solid $error-color;
}
.qr-scanner-green {
  border: 2px solid $success-color;
}
</style>
